
import { Directive, OnDestroy, SkipSelf } from "@angular/core";
import { isEqual } from "lodash";
import { Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { IOnModelChange } from "../../common-form.interface";
import { CommonFieldManagerDirective } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { ChoiceFieldActionsDirective } from "../choicefield-actions.directive";

@Directive({
    selector: "[common-multiselect-actions]",
    exportAs: "MultiselectActions",
})
export class CommonMultiselectActionsDirective implements IOnModelChange, OnDestroy {
    public fieldStateSubscription: Subscription;

    constructor(
        @SkipSelf() public fieldManager: CommonFieldManagerDirective,
        public fieldActions: ChoiceFieldActionsDirective,
        public fieldStateService: FieldStateService,
    ) {
        this.fieldStateSubscription = this.fieldStateService.stateObservable$.pipe(
            distinctUntilChanged((stateA, stateB) => isEqual(stateA, stateB)))
            .subscribe((state) => {
                if (state != null && state.selectedValue != null) {
                    this.fieldManager.dispatchFormFieldChange(state.selectedValue);
                }
            });
    }

    public ngOnDestroy() {
        if (this.fieldStateSubscription) { this.fieldStateSubscription.unsubscribe(); }
    }

    public onModelChange(value) {
        if (value !== this.fieldManager.fieldValue) {
            this.dispatchChanges(value);
        }
    }

    public dispatchChanges(value) {
        this.fieldStateService.transformAndDispatchFieldUpdate(value);
    }
}
